import type { ViewerModel } from '@wix/thunderbolt-symbols'
import type { EnvironmentServiceEditorConfig, EnvironmentServiceSiteConfig } from './types'
import type { IEnvironmentServiceConfig } from '@wix/viewer-service-environment/definition'

export const getServiceConfig = (
	featureConfig: EnvironmentServiceSiteConfig | EnvironmentServiceEditorConfig,
	viewerModel: ViewerModel
): IEnvironmentServiceConfig => {
	return {
		...featureConfig,
		editorType: featureConfig.editorType as IEnvironmentServiceConfig['editorType'],
		requestUrl: viewerModel?.requestUrl,
		isQaMode: viewerModel?.mode.qa,
		viewMode: viewerModel?.viewMode,
		editorName: viewerModel?.site.editorName,
		deviceType: viewerModel?.deviceInfo.deviceClass,
		language: viewerModel?.language?.siteLanguage as IEnvironmentServiceConfig['language'],
	}
}
